const pt = {
  common: {
    wallet: "carteira",
    playPage: "jogar",
    minTop: "valor mínimo é de $10",
    maxTop: "valor máximo é de $500",
    website: "site",
    signOut: "sair",
    hidden: "oculto",
    victory: "vitória",
    wentWrong: "algo deu errado, redirecionando",
    stakeLabel: "aposta",
    howDoes: "como isso funciona?",
    continue: "Continuar",
    continueWithGoogle: "Continuar com o Google",
    continueWithApple: "Continuar com a Apple",
    termsOfService: "termos de serviço",
    privacyPolicy: "política de privacidade",
    termsOfServiceFooter: "termos de serviço",
    privacyPolicyFooter: "política de privacidade",
    verificationCode: "código de verificação",
    verify: "verificar",
    account: "conta",
    error: "ocorreu um erro\n",
    checkBackLater: "verifique novamente mais tarde",
    looking: "procurando...",
    yes: "sim",
    no: "não",
    pleaseSelect: "Por favor selecione\n",
    disclaimer: "ao continuar você concorda com nossos\n",
    and: "e",
  },
  endOfGame: {
    wonByCheckmate: "venceu por xeque-mate",
    lostOnTime: "perdeu por tempo",
    resigns: "desistências",
    gameDrawnByAgreement: "jogo empatado por acordo",
    abandonedTheGame: "abandonou o jogo",
    gameAborted: "jogo abortado",
    gameDrawnByStalemate: "jogo empatado por afogamento",
    gameDrawnByFiftyMoveRule: "jogo empatado pela regra dos cinquenta movimentos",
    gameDrawnByInsufficientMaterial: "jogo empatado por material insuficiente",
    gameDrawnByThreefoldRepetition: "jogo empatado por repetição tripla",
    draw: "empate",
    victory: "vitória",
    defeat: "derrota",
    aborted: "abortado",
    white: "brancas",
    black: "negras",
    inspectBoard: "visualizar tabuleiro",
    returnToEndOfGameModal: "continuar",
  },
  byPhone:{
    continueOnPhone: "continue no\ntelefone",
    or: "ou",
    continueOnWeb: "continue no\nseu navegador",
    disclaimer: "indicado se você tem uma foto da sua identidade no disco"
  },
  signUp: {
    email: "email",
    username: "nome de usuário",
    usernameInvalid: "nome de usuário inválido",
    emailInvalid: "email inválido",
    login: "entrar",
    continueWithPhone: "continue com número de telefone",
    tickBoxes: "vamos marcar algumas\ncaixas",
    confirm: "Eu confirmo que\n",
    resideIn: "Eu resido em\n",
    notPEP: "Não sou uma pessoa exposta politicamente (PEP), um familiar ou associado conhecido de um PEP\n",
    purpose: "O propósito e a natureza da minha relação com Gambit é exclusivamente para usar o serviço para entretenimento\n",
    soleBenefit: "Usarei o serviço exclusivamente para meu benefício e que não há outro beneficiário\n",
  },
  identity: {
    beingVerified: "identidade\nsendo verificada",
    verified: "verificado\n",
    failed: "verificação\nfalhou",
  },
  payment: {
    failed: "pagamento falhou.\ntente novamente",
    successful: "pagamento\nbem-sucedido!",
    toppedUp: "você está\nrecarregado!",
    topUp: "recarregar\n",
    payWith: "pagar com...\n",
  },
  gameplay: {
    play: "jogar\n",
    challenge: "desafia você para um",
    gameWorth: "jogo no valor de\n",
    whatsYourNumber: "qual é o seu\nnúmero?",
    receiveCode: "você receberá um código de verificação\nem breve",
    matchedOpponent: "Você será pareado com um oponente de classificação semelhante.",
    stake: {
      total: "O valor total da aposta será o montante selecionado abaixo.",
      contribution: "Você contribuirá com aproximadamente metade desse valor.",
      weakerOpponent: "Se você for pareado com um oponente mais fraco, pagará uma parte maior da aposta.",
      strongerOpponent: "Se você for pareado com um oponente mais forte, pagará uma parte menor da aposta.",
    },
    supportInfo: "Visite nosso suporte para mais informações.\n",
    continueBrowser: "continue no\nseu navegador",
    continuePhone: "continue no\ntelefone",
    getStarted: "vamos começar",
    sentText: "enviamos para você\num texto",
    enterReceivedCode: "insira o código de verificação\nrecebido",
    wrongCode: "código errado, tente novamente\n",
    secPerMove: "seg/movimento",
    resign: {
      prompt: "tem certeza de que deseja desistir?",
    },
    draw: {
      offer: "aceitar oferta de empate?",
    },
    rating: "classificação\n",
    balance: "saldo\n",
    rematch: "revanche\n",
    newOpponent: "novo oponente\n",
    home: "início\n",
    rematchOffer: "seu oponente oferece uma revanche. aceitar?",
    leaveGame: "Você está jogando uma partida. Tem certeza de que deseja sair?",
    room: "sala:\n",
    gameTypes: {
      bullet: {
        title: "bala\n",
        description: "Xadrez adrenalina. Você e seu oponente recebem apenas 1 minuto cada para vencer o jogo.",
      },
      blitz: {
        title: "blitz\n",
        description: "Você e seu oponente recebem 3 minutos cada para vencer o jogo.",
      },
    },
    stakes: {
      unlockNext: "jogue mais {amount} partidas para desbloquear a próxima aposta",
      allUnlocked: "você desbloqueou todas as apostas",
    },
    withdraw: "retirar\n",
  },
  puzzle: {
    begin: "começar",
    next: "próximo",
    unavailableInYourRegion: "indisponível",
    puzzle: "quebra-cabeça",
    whiteToPlay: "branco para jogar",
    blackToPlay: "preto para jogar",
    time: "tempo",
    solution: "solução",
    somethingWentWrong: "algo deu errado",
    rating: "avaliação",
    credits: "créditos",
    puzzleFailed: "derrota",
    puzzleSolved: "vitória",
    correct: "solução correta",
    incorrect: "solução incorreta",
    youRanOutOfTime: "você ficou sem tempo",
    puzzleDescription: "Você tem 10 segundos + 2 segundos/movimento para resolver um quebra-cabeça.",
    creditsLeft: "créditos restantes",
    refillIn: "reabastecer em",
    lastPuzzle: "este é seu último quebra-cabeça, volte mais tarde para mais.",
    outOfCredits: "você ficou sem créditos, volte mais tarde.",
    locationPrompt: "Precisamos da sua localização para prosseguir. Se estiver bloqueada, reative-a:",
    locationInstructions: "Clique no ícone na barra de endereços, selecione 'Sempre permitir' e atualize a página",
    creditsError: "Erro ao carregar créditos",
    moves: "Jogadas:",
  },
};

export {pt};